/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/shadcnComponents/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/shadcnComponents/ui/card";
import { Input } from "@/shadcnComponents/ui/input";
import { CalendarIcon, Plus, SquareArrowOutUpRight, Trash } from "lucide-react";
import {
  audienceDataFormProps,
  ChargesFormProps,
  collabFormProps,
  contentFormProps,
  monetizationFormProps,
  profileDataFormProps,
  TopLinksFormProps,
  TopLinksPreviewProps,
} from "./BuildProfileProps";
import mixpanel from "mixpanel-browser";
import React, { useEffect, useRef, useState } from "react";
import { Cropper, ReactCropperElement } from "react-cropper";
import { useGeneralSettings } from "@/Providers/General";
import { GoPlus } from "react-icons/go";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcnComponents/ui/select";
import "cropperjs/dist/cropper.css";
import { useNavigate } from "react-router-dom";
import { useStaticData } from "@/Providers/Data";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shadcnComponents/ui/accordion";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/shadcnComponents/ui/alert-dialog";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Label } from "@/shadcnComponents/ui/label";
import { TagsField1 } from "@/Components/Fields";
import { SectionCard } from "@/Pages/Influencer/PublicProfile/Component";
import { ScrollArea, ScrollBar } from "@/shadcnComponents/ui/scroll-area";
import { TbCamera, TbUsers } from "react-icons/tb";
import { MdOpenInNew } from "react-icons/md";
import { FaLink, FaPlus } from "react-icons/fa6";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcnComponents/ui/popover";
import { Calendar } from "@/shadcnComponents/ui/calendar";
import { format } from "date-fns";
import { useAuth } from "@/Providers/Auth";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

export const ProfileForm: React.FC<profileDataFormProps> = ({
  data,
  setData,
  formOneImages,
  setFormOneImages,
  // errorArray,
  onSubmit,
}) => {
  const [openCropModal, setOpenCropModal] = useState({
    value: false,
    index: null,
  });
  const [image, setImage] = useState(null);
  const cropperRef = useRef<ReactCropperElement>(null);
  const [allSocialPlatform] = useState([
    {
      socialPlatformName: "Instagram",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Instagram.svg",
    },
    {
      socialPlatformName: "LinkedIn",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/LinkedIn.svg",
    },
    {
      socialPlatformName: "Telegram",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Telegram.svg",
    },
    {
      socialPlatformName: "Facebook",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Facebook.svg",
    },
    {
      socialPlatformName: "WhatsApp",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Whatsapp.svg",
    },
    {
      socialPlatformName: "YouTube",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/AudiencePlatform/Youtube.svg",
    },
    {
      socialPlatformName: "LinkTree",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/MasterData-Collab/Linktree_logo.svg",
    },
    {
      socialPlatformName: "Twitter",
      socialPlatformLink:
        "https://anchors-collab.s3.ap-south-1.amazonaws.com/MasterData-Collab/twitter_logo.svg",
    },
  ]);

  const generalState = useGeneralSettings();

  const onSaveImage = () => {
    const cropper = cropperRef.current?.cropper;
    setFormOneImages((prev) => {
      const newArr = [...prev];
      newArr[openCropModal?.index] = cropper?.getCroppedCanvas()?.toDataURL();
      return newArr;
    });
    setImage(null);
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleChangeImage = (index) => {
    const input = document.createElement("input");
    input.type = "file";

    input.onchange = (e: any) => {
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }

      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result as any);
        setOpenCropModal({ value: true, index: index });
      };
      reader.readAsDataURL(files[0]);
    };

    input.click();
  };

  const getPlatformNameForLink = (value) => {
    const mapping = {
      Instagram: "instaLink",
      LinkedIn: "linkedinLink",
      Telegram: "telegramLink",
      Facebook: "fbLink",
      WhatsApp: "whatsappLink",
      YouTube: "YouTubeLink",
      LinkTree: "linkTreeLink",
      Twitter: "twitterLink",
    };
    return mapping[value];
  };

  const getPlatformNameForFollower = (value) => {
    const mapping = {
      Instagram: "insta",
      LinkedIn: "linkedin",
      Telegram: "telegram",
      Facebook: "fb",
      WhatsApp: "whatsapp",
      YouTube: "youTube",
      LinkTree: "linktree",
      Twitter: "twitter",
    };
    return mapping[value];
  };

  const getPlatformValue = (value) => {
    const linkKey = getPlatformNameForLink(value);
    const followerKey = getPlatformNameForFollower(value);

    return {
      link: data?.[linkKey] || "",
      follower: data?.followers?.[followerKey] || "",
    };
  };

  const getPlatformSocialLink = (value) => {
    const mapping = {
      Instagram: "https://www.instagram.com/",
      LinkedIn: "https://www.linkedin.com/in/",
      Telegram: "https://telegram.org/",
      Facebook: "https://www.facebook.com/",
      WhatsApp: "https://www.whatsapp.com/",
      YouTube: "https://www.youtube.com/",
      LinkTree: "https://linktr.ee/",
      Twitter: "https://twitter.com/",
    };
    return mapping[value];
  };

  const handleAddPlatform = (e) => {
    e.preventDefault();
    if (allSelectedPlatform?.length < allSocialPlatform?.length) {
      const newPlatform = allSocialPlatform.find(
        (element) =>
          !allSelectedPlatform?.some(
            (selected) =>
              selected.socialPlatformName === element.socialPlatformName
          )
      );
      if (newPlatform) {
        setAllSelectedPlatform((prevData) => {
          return [...prevData, newPlatform];
        });
      }
    }
  };

  const handlePlatformChange = (platformName, index) => {
    const newPlatform = allSocialPlatform.find(
      (platform) => platform.socialPlatformName === platformName
    );
    if (newPlatform) {
      setAllSelectedPlatform((prevPlatforms) => {
        const updatedPlatforms = [...prevPlatforms];
        updatedPlatforms[index] = newPlatform;
        return updatedPlatforms;
      });
    }
  };

  const handleSocialInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSocialFollowerChange = (e, field) => {
    const value = e.target.value >= 0 ? e.target.value : 0;
    setData((prevData) => ({
      ...prevData,
      followers: {
        ...prevData.followers,
        [field]: value,
      },
    }));
  };

  const getInitialPlatforms = () => {
    const getPlatformNameByFollowerName = (value) => {
      const mapping = {
        insta: "Instagram",
        linkedin: "LinkedIn",
        telegram: "Telegram",
        fb: "Facebook",
        whatsapp: "WhatsApp",
        youTube: "YouTube",
        linktree: "LinkTree",
        twitter: "Twitter",
      };
      return mapping[value];
    };

    if (data?.followers) {
      const activePlatforms = Object.keys(data.followers)
        ?.filter((key) => {
          const followerCount = data.followers[key];
          const linkKey = getPlatformNameForLink(
            getPlatformNameByFollowerName(key)
          );
          const linkValue = data[linkKey];
          return (
            (followerCount && followerCount > 0) ||
            (linkValue && linkValue.length > 0)
          );
        })
        ?.map((key) => {
          const platformName = getPlatformNameByFollowerName(key);
          return allSocialPlatform.find(
            (platform) => platform.socialPlatformName === platformName
          );
        })
        ?.filter(Boolean);

      console.log({ activePlatforms });
      return activePlatforms.length > 0
        ? activePlatforms
        : [
            allSocialPlatform.find((p) => p.socialPlatformName === "Instagram"),
            allSocialPlatform.find((p) => p.socialPlatformName === "LinkedIn"),
          ];
    }

    return [
      allSocialPlatform.find((p) => p.socialPlatformName === "Instagram"),
      allSocialPlatform.find((p) => p.socialPlatformName === "LinkedIn"),
    ];
  };

  // Initialize with default platforms and sync with data
  const [allSelectedPlatform, setAllSelectedPlatform] = useState<
    {
      socialPlatformName: string;
      socialPlatformLink: string;
    }[]
  >();
  useEffect(() => {
    setAllSelectedPlatform(getInitialPlatforms());
  }, []);
  return (
    <>
      <Card className="w-full h-max font-inter bg-[#171717] border-[#262626] rounded-[8px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
            <span>
              Profile Information <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                👩🏻‍💻 Tell us a little more about you
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState.SidebarChipsCount.profile || 0}
              {"  "}
              <span className=" ml-[2px] text-[14px] md:text-[16px] ">
                chips
              </span>
            </div>{" "}
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] font-inter text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent className="px-[16px] md:px-6">
          <form className="gap-[20px] flex flex-col">
            {/* profile picture */}
            <section className="flex w-[95px] h-[95px] rounded-full relative flex-col items-start gap-3 z-10">
              {formOneImages[1] ?? data?.profile ? (
                <>
                  <img
                    src={formOneImages[1] ?? data?.profile}
                    alt=""
                    className="w-full h-full bg-[#A6A6A6] rounded-full"
                  />
                  <span
                    onClick={(e) => {
                      e.preventDefault();
                      handleChangeImage(1);
                    }}
                    className=" text-[#FFFFFF]  absolute z-10 bottom-0 right-0 rounded-full bg-[#A6A6A6] cursor-pointer  "
                    color="#FFFFFF"
                  >
                    <GoPlus size={22} />
                  </span>
                </>
              ) : (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handleChangeImage(1);
                  }}
                  className="border bg-[#2f3031] text-[#FFFFFF] border-[#A6A6A6] rounded-full w-full h-full items-center justify-center flex flex-col"
                >
                  <TbCamera />
                  <span className=" text-[12px] ">Add a photo</span>
                </button>
              )}
            </section>
            <div className="flex flex-col w-full items-center gap-4 text-[#A3A3A3] ">
              {/* name and gender */}
              <div className="w-full flex gap-[12px] ">
                <div className="flex w-full flex-col space-y-1.5">
                  {/* <Label htmlFor="name">Name</Label> */}
                  <Input
                    value={data?.name || ""}
                    onChange={handleChange}
                    name="name"
                    id="name"
                    //   error={errorArray?.includes("name")}
                    className=" bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                    placeholder="Ravi Ahirwar"
                  />
                </div>
                <div className="flex w-full flex-col space-y-1.5 ">
                  {/* <Label htmlFor="framework">Framework</Label> */}
                  <Select
                    value={data?.gender || ""}
                    onValueChange={(value) => {
                      setData((prevData) => {
                        return { ...prevData, gender: value };
                      });
                    }}
                  >
                    <SelectTrigger
                      className="bg-transparent text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                      id="gender"
                    >
                      <SelectValue placeholder="Select Gender" />
                    </SelectTrigger>
                    <SelectContent
                      className=" border-[#262626]"
                      position="popper"
                    >
                      <SelectItem value="Male">Male</SelectItem>
                      <SelectItem value="Female">Female</SelectItem>
                      <SelectItem value="Rather not to say">
                        Rather not to say
                      </SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>

              {/* Date of Birth */}
              <div className="w-full flex flex-col space-y-1.5">
                <Popover>
                  <PopoverTrigger asChild>
                    <Button
                      variant="outline"
                      className="bg-transparent text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 justify-start text-left font-normal"
                    >
                      {data?.dob ? (
                        format(data.dob, "PPP")
                      ) : (
                        <span className="text-[#A3A3A3]">Date of Birth</span>
                      )}
                      <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                  </PopoverTrigger>
                  <PopoverContent
                    className="w-auto p-0 border border-[#363636]"
                    align="start"
                  >
                    <Calendar
                      className="rounded-lg shadow-lg"
                      classNames={{ caption_label: "hidden" }}
                      mode="single"
                      selected={data?.dob}
                      onSelect={(date) => {
                        setData((prevData) => {
                          return { ...prevData, dob: date };
                        });
                      }}
                      initialFocus
                      disabled={(date) => date > new Date()}
                      captionLayout="dropdown-buttons"
                      fromYear={1900}
                      toYear={new Date().getFullYear()}
                    />
                  </PopoverContent>
                </Popover>
              </div>
              {/* tagline */}
              <div className="flex w-full flex-col space-y-1.5">
                {/* <Label htmlFor="name">Name</Label> */}
                <Input
                  className=" bg-transparent placeholder:text-[#A3A3A3] text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0  "
                  placeholder="Your tagline"
                  value={data?.tagline || ""}
                  onChange={handleChange}
                  name="tagline"
                  id="tagline"
                />
              </div>
              <span className="w-full h-[0px] bg-[#1A1A1A] "></span>
              {/* social media container */}
              <div className="flex w-full flex-col items-start gap-[12px] self-stretch ">
                {/* social media fields */}
                {allSelectedPlatform?.map((item, index) => {
                  const platformValue = getPlatformValue(
                    item?.socialPlatformName
                  );
                  return (
                    <div
                      key={`${item?.socialPlatformName}-${index}`}
                      className="w-full items-start gap-[12px] flex flex-col md:flex-row self-stretch "
                    >
                      <div className="flex w-full gap-[12px]">
                        <div className="flex w-[80px] flex-col space-y-1.5 ">
                          {/* <Label htmlFor="framework">Framework</Label> */}
                          <Select
                            value={item?.socialPlatformName}
                            onValueChange={(value) => {
                              handlePlatformChange(value, index);
                            }}
                          >
                            <SelectTrigger
                              className="bg-transparent border-[#262626] w-max"
                              id="socialPlatform"
                            >
                              <SelectValue>
                                <img
                                  className="w-[20px] md:w-[25px] h-[20px] md:h-[25px] "
                                  src={item?.socialPlatformLink}
                                  alt={item?.socialPlatformName}
                                />
                              </SelectValue>
                            </SelectTrigger>
                            <SelectContent
                              className=" border-[#262626]"
                              position="popper"
                            >
                              {allSocialPlatform?.map(
                                (platformOption, optionIndex) => {
                                  return (
                                    <SelectItem
                                      key={`${platformOption.socialPlatformName}-${optionIndex}`}
                                      value={platformOption.socialPlatformName}
                                    >
                                      <img
                                        className="w-[20px] md:w-[25px] h-[20px] md:h-[25px]  "
                                        src={platformOption.socialPlatformLink}
                                        alt={platformOption.socialPlatformName}
                                      />
                                    </SelectItem>
                                  );
                                }
                              )}
                            </SelectContent>
                          </Select>
                        </div>
                        <div className="flex w-[200%] flex-col space-y-1.5">
                          {/* <Label htmlFor="name">Name</Label> */}
                          <Input
                            value={platformValue.link}
                            className=" bg-transparent border-[#262626] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] focus-visible:outline-none text-[12px] md:text-[14px] focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                            id={getPlatformNameForLink(
                              item?.socialPlatformName
                            )}
                            name={getPlatformNameForLink(
                              item?.socialPlatformName
                            )}
                            placeholder={"🔗 Paste URL"}
                            onChange={handleSocialInputChange}
                          />
                        </div>
                      </div>
                      <div className="flex w-full gap-[12px]">
                        <div className="flex w-full flex-col space-y-1.5">
                          {/* <Label htmlFor="name">Name</Label> */}
                          <Input
                            type="number"
                            min={0}
                            className=" bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                            id={getPlatformNameForFollower(
                              item?.socialPlatformName
                            )}
                            name={getPlatformNameForFollower(
                              item?.socialPlatformName
                            )}
                            value={platformValue.follower}
                            placeholder="No. of Followers"
                            onChange={(e) =>
                              handleSocialFollowerChange(
                                e,
                                getPlatformNameForFollower(
                                  item?.socialPlatformName
                                )
                              )
                            }
                          />
                        </div>
                        <div className="flex w-full flex-col space-y-1.5">
                          {/* <Label htmlFor="name">Name</Label> */}
                          <Button
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                getPlatformSocialLink(item?.socialPlatformName),
                                "_blank"
                              );
                            }}
                            className="bg-transparent text-[12px] md:text-[14px] flex items-center gap-[8px] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0   "
                          >
                            {" "}
                            Get your URL <MdOpenInNew size={20} />{" "}
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* social media plus button */}
                <div className="w-full items-start gap-[12px]">
                  {allSelectedPlatform?.length < allSocialPlatform?.length && (
                    <Button
                      onClick={(e) => {
                        handleAddPlatform(e);
                      }}
                      className=" bg-transparent border-[#262626] px-[25px] "
                    >
                      <FaPlus />
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </CardContent>
        <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-end">
          <Button
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            className="bg-[#DC2627] hover:bg-[#dc2644] "
          >
            Save & Continue
          </Button>
        </CardFooter>
      </Card>
      {openCropModal?.value && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-20 bg-[#eeeeee7b]">
          <div className="flex flex-col items-center gap-3">
            <Cropper
              ref={cropperRef}
              style={{ height: 400, width: "100%" }}
              initialAspectRatio={openCropModal?.index === 0 ? 3 / 1 : 1}
              src={image}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
              guides={true}
              movable={false}
              cropBoxResizable={false}
              toggleDragModeOnDblclick={false}
            />

            <button
              className="px-5 py-3 bg-red-600 text-white rounded"
              onClick={() => {
                setOpenCropModal({ value: false, index: null });
                onSaveImage();
              }}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
};

// const LocationDataForm: React.FC<profileDataFormProps> = ({
//   data,
//   setData,
//   errorArray,
// }) => {
//   useEffect(() => {
//     if (data?.location?.country !== "India") {
//       setData({
//         ...data,
//         location: { ...data?.location, state: "" },
//       });
//     }
//   }, [data?.location?.country]);

//   const handleChange = (e) => {
//     setData({
//       ...data,
//       location: { ...data?.location, [e.target.name]: e.target.value },
//     });
//   };

//   return (
//     <div className="w-full p-5 box-border bg-white rounded-lg flex flex-col gap-5">
//       <h1>Your Location </h1>

//       <div className="flex gap-[8px]  ">
//         <span className="px-[16px] py-[12px] flex w-[80px] items-center rounded-[4px] bg-[#EEEEEE] text-[12px] leading-[16px] font-[400] text-[#000] ">
//           Country
//         </span>
//         <DropDown01
//           values={countryList?.getNames()}
//           selectedValue={(value) => {
//             setData((prevData) => {
//               return {
//                 ...prevData,
//                 location: { ...prevData?.location, country: value },
//               };
//             });
//           }}
//           defaultValue={data?.location?.country}
//           placeholder={""}
//           error={errorArray?.includes("country")}
//         />
//       </div>
//       {data?.location?.country === "India" && (
//         <div className="flex gap-[8px]  ">
//           <span className="px-[16px] py-[12px] flex w-[80px] items-center rounded-[4px] bg-[#EEEEEE] text-[12px] leading-[16px] font-[400] text-[#000] ">
//             State
//           </span>
//           <InputField1
//             value={data?.location?.state}
//             onChange={handleChange}
//             icon={undefined}
//             placeholder="Enter Your state"
//             name="state"
//             id="state"
//             error={errorArray?.includes("state")}
//           />
//         </div>
//       )}
//       <div className="flex gap-[8px]  ">
//         <span className="px-[16px] py-[12px] flex w-[80px] items-center rounded-[4px] bg-[#EEEEEE] text-[12px] leading-[16px] font-[400] text-[#000] ">
//           City
//         </span>
//         <InputField1
//           value={data?.location?.city}
//           onChange={handleChange}
//           icon={undefined}
//           placeholder="Enter Your city"
//           name="city"
//           id="city"
//           error={errorArray?.includes("city")}
//         />
//       </div>
//     </div>
//   );
// };

export const CollabForm: React.FC<collabFormProps> = ({
  data,
  setData,
  // formTwoImages,
  // setFormTwoImages,
  errorArray,
  onSubmit,
}) => {
  const navigate = useNavigate();
  const staticData = useStaticData();
  const generalState = useGeneralSettings();
  //   const [openCropModal, setOpenCropModal] = useState({
  //     value: false,
  //     index: null,
  //   });
  const [openDeleteAction, SetOpenDeleteAction] = useState(false);
  const [openLastCard, setOpenLastCard] = useState(false);
  // const [image, setImage] = useState(null);
  //   const cropperRef = useRef<ReactCropperElement>(null);
  const [chipsData, setChipsData] = useState<string | object>();

  const [tagsData, setTagsData] = useState<[] | any>();

  const handleChangeData = (value: string, index: number, field: string) => {
    setData((prevData) => {
      const newArray = [...prevData];
      const updatedObj = newArray[index];
      updatedObj[field] = value.trim(); // added trim, to prevent empty spaces
      newArray[index] = updatedObj;
      return newArray;
    });
  };
  const handleAddCompany = () => {
    setOpenLastCard(false);
    setData((prev) => [
      ...prev,
      {
        companyName: "",
        companyUrl: "",
        companyProfile: "",
        postLink: "",
        goals: [],
      },
    ]);
    setOpenLastCard(true);
  };
  const handleDeleteCompany = async (index) => {
    setData((prevData) => {
      const newArray = [...prevData];
      newArray.splice(index, 1);
      return newArray;
    });
    SetOpenDeleteAction(true);
  };
  const handleDeleteEmptyCompany = async (index) => {
    setData((prevData) => {
      const newArray = [...prevData];
      newArray.splice(index, 1);
      return newArray;
    });
    setOpenLastCard(false);
  };
  const getChipsOfCard = (item) => {
    let totalChips = 0;
    if (chipsData) {
      if (item?.companyName?.length > 1) {
        totalChips += chipsData["collab.companyName"];
      }
      if (item?.companyUrl?.length > 1) {
        totalChips += chipsData["collab.companyUrl"];
      }
      if (item?.postLink) {
        totalChips += chipsData["collab.postLink"];
      }
      if (item?.goals?.length > 1) {
        totalChips += chipsData["collab.goals"];
      }
    }
    return totalChips;
  };
  // const onSaveImage = () => {
  //   const cropper = cropperRef.current?.cropper;
  //   setFormTwoImages((prev) => {
  //     let newArr = [...prev];
  //     newArr[openCropModal?.index] = cropper?.getCroppedCanvas()?.toDataURL();
  //     return newArr;
  //   });
  //   setImage(null);
  // };
  useEffect(() => {
    staticData?.getNewDataFromType("Goal / KPI").then((e) => {
      setTagsData(e);
    });
    staticData.getDataFromType("Influencer Chips").then((e) => {
      setChipsData(e[0]);
    });
  }, []);
  useEffect(() => {
    if (openDeleteAction) {
      onSubmit({ noNavigate: true });
      SetOpenDeleteAction(false);
      setOpenLastCard(false);
    }
  }, [openDeleteAction]);
  useEffect(() => {
    if (openLastCard) {
      const doc = document.getElementById(`collabCard${data?.length - 1}`);
      doc?.scrollIntoView({ behavior: "smooth" });
    }
  }, [openLastCard, data?.length]);

  // const handleChangeImage = (index) => {
  //   const input = document.createElement("input");
  //   input.type = "file";

  //   input.onchange = (e) => {
  //     let files;
  //     if (e.dataTransfer) {
  //       files = e.dataTransfer.files;
  //     } else if (e.target) {
  //       files = e.target.files;
  //     }

  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImage(reader.result as any);
  //       setOpenCropModal({ value: true, index: index });
  //     };
  //     reader.readAsDataURL(files[0]);
  //   };

  //   // Move e.preventDefault() here to prevent the default file dialog from opening
  //   input.click();
  // };

  return (
    <>
      <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className="text-[#FFFFFF] text-[14px] md:text-[16px] flex gap-[10px] ">
            <span>
              Showcase Your Collaborations <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                🫱🏼‍🫲🏽 Add past collaboration details and impress brands with
                your versatility and expertise
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState.SidebarChipsCount.collab || 0}{" "}
              <span className=" ml-[2px] text-[14px] md:text-[16px]  ">
                chips
              </span>
            </div>{" "}
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
          {data?.map((e, index) => {
            return (openLastCard
              ? index < data?.length - 1
              : index <= data?.length - 1 && data?.length > 1) &&
              e?.companyName?.length > 1 &&
              e?.companyUrl?.length > 1 &&
              e?.postLink?.length > 1 ? (
              <Accordion
                className="w-full p-[16px] md:p-[20px] border border-[#262626] rounded-[8px] "
                type="single"
                collapsible
                id={`collabCard${index}`}
              >
                <AccordionItem value="item-1">
                  <AccordionTrigger className="[&[data-state=open]>div]:hidden data-[state=closed]:justify-between data-[state=open]:justify-end items-start text-[color:var(--Shade-White,#FFF)] flex-1 pb-0">
                    <div className="items-start flex flex-1 flex-col gap-[12px] data-[state=open]:hidden">
                      <div className="items-center mt-[-4px] w-[98%] justify-between flex gap-[8px] @apply text-[color:var(--Shade-White,#FFF)] text-xs md:text-base not-italic font-semibold leading-[normal];">
                        <div className="flex gap-[8px] items-center">
                          {e?.companyName}{" "}
                          <FaLink
                            onClick={() => {
                              if (!/^https?:\/\//i.test(e?.postLink)) {
                                const postLink = "https://" + e?.postLink;
                                return window.open(postLink, "_blank");
                              } else {
                                window.open(e?.postLink, "_blank");
                              }
                            }}
                            color="red"
                            size={18}
                          />
                        </div>
                        <div className="@apply text-[#A6A6A6] text-xs md:text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                          Earned 💸 {getChipsOfCard(e)} chips
                        </div>
                      </div>
                      <div className="flex flex-wrap gap-[4px]">
                        {e.goals?.map((item, index) => {
                          return (
                            <div
                              className="flex items-center justify-center px-[12px] py-[4px] bg-[#333333] text-[#A3A3A3] text-[12px] md:text-[14px] font=[500] leading-[24px] rounded-[6px] border border-[#262626] "
                              key={index}
                            >
                              {
                                tagsData?.find((tag: any) => tag?._id === item)
                                  ?.CollabGoalsName
                              }
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </AccordionTrigger>
                  <div className="w-full flex-1 [&[data-state=open]>div]:hidden flex justify-end gap-[4px]">
                    <AlertDialog>
                      <AlertDialogTrigger
                        className={
                          "bg-transparent border-none hover:bg-[none] px-[0] "
                        }
                        asChild
                      >
                        <Button
                          className="hover:text-[#FFF] text-[#A6A6A6]"
                          variant="outline"
                        >
                          <RiDeleteBin6Line cursor={"pointer"} size={18} />
                        </Button>
                      </AlertDialogTrigger>
                      <AlertDialogContent>
                        <AlertDialogHeader>
                          <AlertDialogTitle>
                            Are you absolutely sure?
                          </AlertDialogTitle>
                          <AlertDialogDescription>
                            This action cannot be undone. This will permanently
                            remove your data from our servers.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Cancel</AlertDialogCancel>
                          <AlertDialogAction
                            onClick={() => handleDeleteCompany(index)}
                          >
                            Continue
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>
                  </div>
                  <AccordionContent>
                    <Card className="w-full font-inter bg-[#171717] border-none gap-[20px] ">
                      <CardContent className="px-[0] md:px-6 flex flex-col gap-[40px] ">
                        <div className="flex flex-col gap-3 w-full">
                          <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                            <Label
                              className="text-[#E2E8F0] text-[12px] md:text-[14px] "
                              htmlFor="companyName"
                            >
                              Company Name
                            </Label>
                            <Input
                              value={e.companyName}
                              onChange={(e) =>
                                handleChangeData(
                                  e.target.value,
                                  index,
                                  e.target.name
                                )
                              }
                              name="companyName"
                              id="companyName"
                              // error={errorArray?.includes(
                              //   "collab" + index + "companyName"
                              // )}
                              className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                                errorArray?.includes(
                                  "collab" + index + "companyName"
                                )
                                  ? "border-[#dc2627]"
                                  : "border-[#262626]"
                              }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                            />
                          </div>
                          <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                            <Label
                              className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                              htmlFor="companyName"
                            >
                              Company Website URL
                            </Label>
                            <Input
                              value={e.companyUrl}
                              onChange={(e) =>
                                handleChangeData(
                                  e.target.value,
                                  index,
                                  e.target.name
                                )
                              }
                              name="companyUrl"
                              id="companyUrl"
                              // error={errorArray?.includes(
                              //   "collab" + index + "companyUrl"
                              // )}
                              className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                                errorArray?.includes(
                                  "collab" + index + "companyUrl"
                                )
                                  ? "border-[#dc2627]"
                                  : "border-[#262626]"
                              }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                            />
                          </div>
                          <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                            <Label
                              className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                              htmlFor="companyName"
                            >
                              Collaboration Post Link
                            </Label>
                            <Input
                              placeholder="🔗 Paste URL"
                              value={e.postLink}
                              onChange={(e) =>
                                handleChangeData(
                                  e.target.value,
                                  index,
                                  e.target.name
                                )
                              }
                              name="postLink"
                              id="postLink"
                              // error={errorArray?.includes(
                              //   "collab" + index + "postLink"
                              // )}
                              className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                                errorArray?.includes(
                                  "collab" + index + "postLink"
                                )
                                  ? "border-[#dc2627]"
                                  : "border-[#262626]"
                              }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                            />
                          </div>
                        </div>
                        <div className="flex flex-col gap-[12px]">
                          <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
                            Select the goals that applied to this collaboration
                            (SELECT ALL THAT APPLY)
                          </span>
                          <div className="flex flex-wrap gap-[12px]">
                            <TagsField1
                              data={tagsData ?? []}
                              values={e.goals}
                              setValues={(value: []) => {
                                setData((prevData) => {
                                  const newArray = [...prevData];
                                  const updatedObj = newArray[index];
                                  updatedObj.goals = value;
                                  newArray[index] = updatedObj;
                                  return newArray;
                                });
                              }}
                              tagName={"CollabGoalsName"}
                            />
                          </div>
                        </div>
                      </CardContent>
                      <CardFooter className="flex justify-start">
                        <div className="flex gap-[12px] ">
                          <Button
                            onClick={(e) => {
                              e.preventDefault();
                              onSubmit({ noNavigate: true });
                              setOpenLastCard(false);
                            }}
                            className="bg-[#DC2627] hover:bg-[#dc2644] "
                          >
                            Save Details
                          </Button>
                        </div>
                      </CardFooter>
                    </Card>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ) : (
              <Card
                id={`collabCard${index}`}
                className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] "
              >
                <CardHeader className=" gap-[0px] ">
                  <CardDescription className=" text-[#A3A3A3] text-[12px] md:text-[14px] flex justify-end items-center mt-0 ">
                    <Button
                      className="hover:text-[#FFF] text-[#A6A6A6] bg-transparent border-none hover:bg-transparent "
                      variant="outline"
                      onClick={() => handleDeleteEmptyCompany(index)}
                    >
                      <RiDeleteBin6Line cursor={"pointer"} size={18} />
                    </Button>
                  </CardDescription>
                </CardHeader>
                <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
                  <div className="flex flex-col gap-3 w-full">
                    <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                      <Label
                        className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                        htmlFor="companyName"
                      >
                        Company Name
                      </Label>
                      <Input
                        value={e.companyName}
                        onChange={(e) =>
                          handleChangeData(e.target.value, index, e.target.name)
                        }
                        name="companyName"
                        id="companyName"
                        //   error={errorArray?.includes(
                        //     "collab" + index + "companyName"
                        //   )}
                        className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                          errorArray?.includes("collab" + index + "companyName")
                            ? "border-[#dc2627]"
                            : "border-[#262626]"
                        }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                      />
                    </div>
                    <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                      <Label
                        className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                        htmlFor="companyName"
                      >
                        Company Website URL
                      </Label>
                      <Input
                        value={e.companyUrl}
                        onChange={(e) =>
                          handleChangeData(e.target.value, index, e.target.name)
                        }
                        name="companyUrl"
                        id="companyUrl"
                        //   error={errorArray?.includes(
                        //     "collab" + index + "companyUrl"
                        //   )}
                        className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                          errorArray?.includes("collab" + index + "companyUrl")
                            ? "border-[#dc2627]"
                            : "border-[#262626]"
                        }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                      />
                    </div>
                    <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                      <Label
                        className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                        htmlFor="companyName"
                      >
                        Collaboration Post Link
                      </Label>
                      <Input
                        placeholder="🔗 Paste URL"
                        value={e.postLink}
                        onChange={(e) =>
                          handleChangeData(e.target.value, index, e.target.name)
                        }
                        name="postLink"
                        id="postLink"
                        //   error={errorArray?.includes(
                        //     "collab" + index + "postLink"
                        //   )}
                        className={`bg-transparent text-[#fff] text-[12px] md:text-[14px] placeholder:text-[#A3A3A3] ${
                          errorArray?.includes("collab" + index + "postLink")
                            ? "border-[#dc2627]"
                            : "border-[#262626]"
                        }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                      />
                    </div>
                  </div>
                  <div className="flex flex-col gap-[12px]">
                    <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
                      Select the goals that applied to this collaboration
                      (SELECT ALL THAT APPLY)
                    </span>
                    <div className="flex flex-wrap gap-[12px]">
                      <TagsField1
                        data={tagsData ?? []}
                        values={e.goals}
                        setValues={(value: []) => {
                          setData((prevData) => {
                            const newArray = [...prevData];
                            const updatedObj = newArray[index];
                            updatedObj.goals = value;
                            newArray[index] = updatedObj;
                            return newArray;
                          });
                        }}
                        tagName={"CollabGoalsName"}
                      />
                    </div>
                  </div>
                </CardContent>
                <CardFooter className="flex justify-start">
                  <div className="flex gap-[12px] ">
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        onSubmit({ noNavigate: true });
                        setOpenLastCard(false);
                      }}
                      className="bg-[#DC2627] hover:bg-[#dc2644] "
                    >
                      Save Details
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            );
          })}
        </CardContent>
        <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-between">
          <div className="hidden md:flex gap-[12px] ">
            <Button
              onClick={() => {
                navigate("/influencer/build_profile?page=monetization");
              }}
              className="bg-transparent text-[#E2E8F0] hover:bg-[#381c1c] "
            >
              I’ll do it later
            </Button>
          </div>
          <div className="w-full md:w-auto flex justify-between gap-[12px] ">
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleAddCompany();
              }}
              className="bg-transparent text-[#E2E8F0] ml-[-10%] md:ml-auto border border-[#E2E8F0] hover:bg-[#381c1c] "
            >
              + Add More
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                onSubmit({ noNavigate: false });
              }}
              className="bg-[#DC2627] hover:bg-[#dc2644] "
            >
              Save & Continue
            </Button>
          </div>
        </CardFooter>
      </Card>

      {/* <div
          className="w-full p-5 box-border bg-white rounded-lg flex flex-col gap-5 items-start font-inter"
          style={{ boxShadow: "0px 0px 8px 0px rgba(33, 33, 33, 0.08)" }}
        >
          {data?.map((e, index) => {
            return (
              <div className="w-full rounded border border-[#E0E0E0] p-5 box-border flex flex-col gap-5">
                <section className="flex items-start gap-5">
                  <div className="flex flex-col items-center gap-1">
                    <div className="relative">
                      <img
                        src={
                          formTwoImages[index] ??
                          e.companyProfile ??
                          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/2048px-No_image_available.svg.png"
                        }
                        alt=""
                        className="w-16  rounded-full"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src =
                            "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/2048px-No_image_available.svg.png";
                        }}
                      />
                      <span
                        className="absolute right-0 bottom-0 bg-[#BDBDBD] border border-[#9e9e9e] text-[#757575] rounded-full p-1 cursor-pointer"
                        onClick={() => {
                          handleChangeImage(index);
                        }}
                      >
                        <TbEdit />
                      </span>
                    </div>
                    <span className="font-inter text-[#757575] font-medium">
                      Logo
                    </span>
                  </div> 
                </section>
              </div>
            );
          })
        </div> */}
      {/* {openCropModal?.value && (
        <div className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-20 bg-[#eeeeee7b]">
          <div className="flex flex-col items-center gap-3">
            <Cropper
              ref={cropperRef}
              style={{ height: 400, width: "100%" }}
              initialAspectRatio={1}
              src={image}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
              guides={true}
              movable={false}
              cropBoxResizable={false}
            />

            <button
              className="px-5 py-3 bg-red-600 text-white rounded"
              onClick={() => {
                setOpenCropModal({ value: false, index: null });
                onSaveImage();
              }}
            >
              Save
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};

export const MonetizationForm: React.FC<monetizationFormProps> = ({
  data,
  setData,
  errorArray,
  onSubmit,
}) => {
  const staticData = useStaticData();
  const navigate = useNavigate();
  const [tagsData, setTagsData] = useState<[] | any>();
  const [platformData, setPlatformData] = useState<[] | any>();
  const [chipsData, setChipsData] = useState<string | object>();
  const generalState = useGeneralSettings();
  const [openDeleteAction, SetOpenDeleteAction] = useState(false);
  const [openLastCard, setOpenLastCard] = useState(false);

  const handleChangeData = (value: string, index: number, field: string) => {
    setData((prevData) => {
      const newArray = [...prevData];
      const updatedObj = newArray[index];
      updatedObj[field] = value;
      newArray[index] = updatedObj;
      return newArray;
    });
  };
  const handleAddCompany = async () => {
    setOpenLastCard(false);
    setData((prev) => [
      ...prev,
      {
        platformName: "",
        profileLink: "",
        paidAudience: null,
        methods: [],
      },
    ]);
    setOpenLastCard(true);
  };
  const handleDeleteCompany = async (index) => {
    setData((prevData) => {
      const newArray = [...prevData];
      newArray.splice(index, 1);
      return newArray;
    });
    SetOpenDeleteAction(true);
  };
  const handleDeleteEmptyCompany = async (index) => {
    setData((prevData) => {
      const newArray = [...prevData];
      newArray.splice(index, 1);
      return newArray;
    });
    setOpenLastCard(false);
  };

  const getChipsOfCard = (item) => {
    let totalChips = 0;
    if (chipsData) {
      if (item?.platformName?.length > 1) {
        totalChips += chipsData["monetisation.platformName"];
      }
      if (item?.profileLink?.length > 1) {
        totalChips += chipsData["monetisation.profileLink"];
      }
      if (item?.paidAudience) {
        totalChips += chipsData["monetisation.paidAudience"];
      }
      if (item?.methods?.length > 1) {
        totalChips += chipsData["monetisation.methods"];
      }
    }
    return totalChips;
  };

  useEffect(() => {
    staticData?.getNewDataFromType("Services list").then((e) => {
      setTagsData(e);
    });

    staticData?.getNewDataFromType("Platform Name").then((e) => {
      setPlatformData(e);
    });
    staticData.getDataFromType("Influencer Chips").then((e) => {
      setChipsData(e[0]);
    });
  }, []);
  useEffect(() => {
    if (openDeleteAction) {
      onSubmit({ noNavigate: true });
      SetOpenDeleteAction(false);
      setOpenLastCard(false);
    }
  }, [openDeleteAction]);
  useEffect(() => {
    if (openLastCard) {
      const doc = document.getElementById(
        `monetizationCard${data?.length - 1}`
      );
      doc?.scrollIntoView({ behavior: "smooth" });
    }
  }, [openLastCard, data?.length]);
  const findPlatformName = (e) => {
    const masterItem: any = platformData?.find((item: any) => {
      return item?._id?.includes(e?.platformName);
    });
    return masterItem?.monetizationPlatformName;
  };
  return (
    <>
      <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className="text-[#FFFFFF] text-[14px] md:text-[16px] flex gap-[10px] ">
            <span>
              Monetisation Expertise <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                💰 Show your ability to connect with & convert your followers,
                making you a valuable brand partner
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[32px] h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState?.SidebarChipsCount?.monetization || 0}{" "}
              <span className=" ml-[2px] text-[14px] md:text-[16px] ">
                chips
              </span>
            </div>{" "}
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
          {data?.map((e, index) => {
            return (openLastCard
              ? index < data?.length - 1
              : index <= data?.length - 1 && data?.length > 1) &&
              (findPlatformName(e)?.length > 1 ||
                findPlatformName(e) === "None") &&
              (e?.profileLink?.length > 1 || findPlatformName(e) === "None") &&
              (findPlatformName(e) === "None" || e?.paidAudience) ? (
              <Accordion
                className="w-full p-[16px] md:p-[20px] border border-[#262626] rounded-[8px] "
                type="single"
                collapsible
                id={`monetizationCard${index}`}
              >
                <AccordionItem value="item-1">
                  <AccordionTrigger className="[&[data-state=open]>div]:hidden data-[state=closed]:justify-between data-[state=open]:justify-end items-start text-[color:var(--Shade-White,#FFF)] flex-1 pb-0">
                    <div className="items-start flex flex-1 flex-col gap-[12px] data-[state=open]:hidden">
                      <div className="items-center mt-[-5px] w-[98%] justify-between flex gap-[8px] @apply text-[color:var(--Shade-White,#FFF)] text-xs  md:text-base not-italic font-semibold leading-[normal];">
                        <div className="flex gap-[8px] items-center">
                          {findPlatformName(e)}{" "}
                          {findPlatformName(e) === "None" ? (
                            ""
                          ) : (
                            <FaLink
                              onClick={() => {
                                if (!/^https?:\/\//i.test(e?.profileLink)) {
                                  const profileLink =
                                    "https://" + e?.profileLink;
                                  return window.open(profileLink, "_blank");
                                } else {
                                  window.open(e?.profileLink, "_blank");
                                }
                              }}
                              color="red"
                              size={18}
                            />
                          )}
                        </div>
                        <div className="@apply text-[#A6A6A6] text-xs md:text-sm not-italic font-medium leading-5 tracking-[0.14px]">
                          Earned 💸 {getChipsOfCard(e)} chips
                        </div>
                      </div>
                      {findPlatformName(e) !== "None" && (
                        <div className="flex items-center gap-[8px] @apply text-neutral-400 text-xs md:text-base not-italic font-semibold leading-[normal]">
                          <TbUsers color="#3771C8" size={16} />{" "}
                          {e?.paidAudience}
                        </div>
                      )}
                      {findPlatformName(e) !== "None" && (
                        <div className="flex flex-wrap gap-[4px]">
                          {e.methods?.map((item, index) => {
                            return (
                              <div
                                className="flex items-center justify-center px-[12px] py-[4px] bg-[#333333] text-[#A3A3A3] text-xs md:text-[14px] font=[500] leading-[24px] rounded-[6px] border border-[#262626] "
                                key={index}
                              >
                                {
                                  tagsData?.find(
                                    (tag: any) => tag?._id === item
                                  )?.monetizationServiceName
                                }
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </AccordionTrigger>
                  <div className="w-full flex-1 [&[data-state=open]>div]:hidden flex justify-end gap-[4px]">
                    <AlertDialog>
                      <AlertDialogTrigger
                        className={
                          "bg-transparent border-none hover:bg-[none] px-[0] "
                        }
                        asChild
                      >
                        <Button
                          className="hover:text-[#FFF] text-[#A6A6A6]"
                          variant="outline"
                        >
                          <RiDeleteBin6Line cursor={"pointer"} size={18} />
                        </Button>
                      </AlertDialogTrigger>
                      <AlertDialogContent>
                        <AlertDialogHeader>
                          <AlertDialogTitle>
                            Are you absolutely sure?
                          </AlertDialogTitle>
                          <AlertDialogDescription>
                            This action cannot be undone. This will permanently
                            remove your data from our servers.
                          </AlertDialogDescription>
                        </AlertDialogHeader>
                        <AlertDialogFooter>
                          <AlertDialogCancel>Cancel</AlertDialogCancel>
                          <AlertDialogAction
                            onClick={() => handleDeleteCompany(index)}
                          >
                            Continue
                          </AlertDialogAction>
                        </AlertDialogFooter>
                      </AlertDialogContent>
                    </AlertDialog>
                  </div>
                  <AccordionContent>
                    <Card className="w-full font-inter bg-[#171717] border-none gap-[20px] ">
                      <CardContent className="px-0 md:px-6 flex flex-col gap-[40px] ">
                        <div className="flex flex-col gap-3 w-full">
                          <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                            <Label
                              className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                              htmlFor={`dropDownPlatform${index}`}
                            >
                              Select Platform
                            </Label>
                            <Select
                              onValueChange={(value) => {
                                setData((prevData) => {
                                  const newArray = [...prevData];
                                  const updatedObj = newArray[index];
                                  updatedObj.platformName = value;
                                  updatedObj.methods =
                                    platformData?.find(
                                      (item: any) => item?._id === value
                                    )?.monetizationPlatformName === "None"
                                      ? null
                                      : updatedObj.methods;
                                  newArray[index] = updatedObj;
                                  return newArray;
                                });
                              }}
                            >
                              <SelectTrigger
                                className="bg-transparent border-[#262626] text-[#fff] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 text-[12px] md:text-[14px]"
                                id="gender"
                              >
                                <SelectValue
                                  placeholder={findPlatformName(e)}
                                />
                              </SelectTrigger>
                              <SelectContent
                                className=" border-[#262626] text-[12px] md:text-[14px]"
                                position="popper"
                              >
                                {platformData?.map((item: any, index) => {
                                  return (
                                    <SelectItem key={index} value={item?._id}>
                                      {item?.monetizationPlatformName}
                                    </SelectItem>
                                  );
                                })}
                              </SelectContent>
                            </Select>
                          </div>
                          {findPlatformName(e) !== "None" && (
                            <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                              <Label
                                className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                                htmlFor="companyName"
                              >
                                Enter Profile Link
                              </Label>
                              <Input
                                value={e.profileLink}
                                onChange={(e) =>
                                  handleChangeData(
                                    e.target.value,
                                    index,
                                    e.target.name
                                  )
                                }
                                name="profileLink"
                                id="profileLink"
                                //   error={errorArray?.includes(
                                //     "monetization" + index + "profileLink"
                                //   )}
                                className={`bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] ${
                                  errorArray?.includes(
                                    "monetization" + index + "profileLink"
                                  )
                                    ? "border-[#dc2627]"
                                    : "border-[#262626]"
                                }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                                placeholder="🔗 Paste URL"
                              />
                            </div>
                          )}
                          {findPlatformName(e) !== "None" && (
                            <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                              <Label
                                className="text-[#E2E8F0]"
                                htmlFor="companyName"
                              >
                                Total Paid Audience
                              </Label>
                              <Input
                                placeholder="Total Paid Audience"
                                type="number"
                                value={e.paidAudience}
                                onChange={(e) =>
                                  handleChangeData(
                                    e.target.value,
                                    index,
                                    e.target.name
                                  )
                                }
                                name="paidAudience"
                                id="paidAudience"
                                //   error={errorArray?.includes(
                                //     "monetization" + index + "paidAudience"
                                //   )}
                                className={` bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 ${
                                  errorArray?.includes(
                                    "monetization" + index + "paidAudience"
                                  )
                                    ? "border-[#dc2627]"
                                    : "border-[#262626]"
                                }  `}
                              />
                            </div>
                          )}
                        </div>
                        {findPlatformName(e) !== "None" && (
                          <div className="flex flex-col gap-[12px]">
                            <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
                              Which monetization methods do you utilize? (SELECT
                              ALL THAT APPLY)
                            </span>
                            <div className="flex flex-wrap gap-[12px]">
                              <TagsField1
                                data={tagsData ?? []}
                                values={e.methods}
                                setValues={(value: []) => {
                                  setData((prevData) => {
                                    const newArray = [...prevData];
                                    const updatedObj = newArray[index];
                                    updatedObj.methods = value;
                                    newArray[index] = updatedObj;
                                    return newArray;
                                  });
                                }}
                                tagName={"monetizationServiceName"}
                              />
                            </div>
                          </div>
                        )}
                      </CardContent>
                      <CardFooter className="flex justify-start">
                        <div className="flex gap-[12px] ">
                          <Button
                            onClick={(e) => {
                              e.preventDefault();
                              onSubmit({ noNavigate: true });
                              setOpenLastCard(false);
                            }}
                            className="bg-[#DC2627] hover:bg-[#dc2644] "
                          >
                            Save Details
                          </Button>
                        </div>
                      </CardFooter>
                    </Card>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ) : (
              <Card
                id={`monetizationCard${index}`}
                className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] "
              >
                <CardHeader className="w-full gap-[0px] ">
                  <CardDescription className="w-full text-[#A3A3A3] text-[12px] md:text-[14px] flex justify-end items-center mt-0 ">
                    <Button
                      className="hover:text-[#FFF] text-[#A6A6A6] bg-transparent border-none hover:bg-transparent "
                      variant="outline"
                      onClick={() => handleDeleteEmptyCompany(index)}
                    >
                      <RiDeleteBin6Line cursor={"pointer"} size={18} />
                    </Button>
                  </CardDescription>
                </CardHeader>
                <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
                  <div className="flex flex-col gap-3 w-full">
                    <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                      <Label
                        className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                        htmlFor={`dropDownPlatform${index}`}
                      >
                        Select Platform
                      </Label>
                      <Select
                        //   id={`dropDownPlatform${index}`}
                        defaultValue={findPlatformName(e)}
                        onValueChange={(value) => {
                          setData((prevData) => {
                            const newArray = [...prevData];
                            const updatedObj = newArray[index];
                            updatedObj.platformName = value;
                            updatedObj.methods =
                              platformData?.find(
                                (item: any) => item?._id === value
                              )?.monetizationPlatformName === "None"
                                ? null
                                : updatedObj.methods;
                            newArray[index] = updatedObj;
                            return newArray;
                          });
                        }}
                      >
                        <SelectTrigger
                          className="bg-transparent border-[#262626] text-[#fff] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 text-[12px] md:text-[14px]"
                          id="gender"
                        >
                          <SelectValue placeholder={findPlatformName(e)} />
                        </SelectTrigger>
                        <SelectContent
                          className=" border-[#262626] text-[12px] md:text-[14px]"
                          position="popper"
                        >
                          {platformData?.map((item: any, index) => {
                            return (
                              <SelectItem key={index} value={item?._id}>
                                {item?.monetizationPlatformName}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                    </div>

                    {findPlatformName(e) !== "None" && (
                      <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                        <Label
                          className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                          htmlFor="companyName"
                        >
                          Enter Profile Link
                        </Label>
                        <Input
                          value={e.profileLink}
                          onChange={(e) =>
                            handleChangeData(
                              e.target.value,
                              index,
                              e.target.name
                            )
                          }
                          name="profileLink"
                          id="profileLink"
                          // error={errorArray?.includes(
                          //   "monetization" + index + "profileLink"
                          // )}
                          className={`bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] ${
                            errorArray?.includes(
                              "monetization" + index + "profileLink"
                            )
                              ? "border-[#dc2627]"
                              : "border-[#262626]"
                          }  focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0`}
                          placeholder="🔗 Paste URL"
                        />
                      </div>
                    )}
                    {findPlatformName(e) !== "None" && (
                      <div className="flex w-full md:w-1/2 flex-col space-y-1.5">
                        <Label
                          className="text-[#E2E8F0] text-[12px] md:text-[14px]"
                          htmlFor="companyName"
                        >
                          Total Paid Audience
                        </Label>
                        <Input
                          placeholder="Total Paid Audience"
                          type="number"
                          value={e.paidAudience}
                          onChange={(e) =>
                            handleChangeData(
                              e.target.value,
                              index,
                              e.target.name
                            )
                          }
                          name="paidAudience"
                          id="paidAudience"
                          // error={errorArray?.includes(
                          //   "monetization" + index + "paidAudience"
                          // )}
                          className={` bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 ${
                            errorArray?.includes(
                              "monetization" + index + "paidAudience"
                            )
                              ? "border-[#dc2627]"
                              : "border-[#262626]"
                          }  `}
                        />
                      </div>
                    )}
                  </div>
                  {findPlatformName(e) !== "None" && (
                    <div className="flex flex-col gap-[12px]">
                      <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
                        Which monetization methods do you utilize? (SELECT ALL
                        THAT APPLY)
                      </span>
                      <div className="flex flex-wrap gap-[12px]">
                        <TagsField1
                          data={tagsData ?? []}
                          values={e.methods}
                          setValues={(value: []) => {
                            setData((prevData) => {
                              const newArray = [...prevData];
                              const updatedObj = newArray[index];
                              updatedObj.methods = value;
                              newArray[index] = updatedObj;
                              return newArray;
                            });
                          }}
                          tagName={"monetizationServiceName"}
                        />
                      </div>
                    </div>
                  )}
                </CardContent>
                <CardFooter className="flex justify-start">
                  <div className="flex gap-[12px] ">
                    <Button
                      onClick={(e) => {
                        e.preventDefault();
                        onSubmit({ noNavigate: true });
                        setOpenLastCard(false);
                      }}
                      className="bg-[#DC2627] hover:bg-[#dc2644] "
                    >
                      Save Details
                    </Button>
                  </div>
                </CardFooter>
              </Card>
            );
          })}
        </CardContent>
        <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-between">
          <div className="hidden md:flex gap-[12px] ">
            <Button
              onClick={() => {
                navigate("/influencer/build_profile?page=pricing");
              }}
              className="bg-transparent text-[#E2E8F0] hover:bg-[#381c1c] "
            >
              I’ll do it later
            </Button>
          </div>
          <div className="w-full md:w-auto   flex justify-between gap-[12px] ">
            <Button
              onClick={(e) => {
                e.preventDefault();
                handleAddCompany();
              }}
              className="bg-transparent text-[#E2E8F0] ml-[-10%] md:ml-auto border border-[#E2E8F0] hover:bg-[#381c1c] "
            >
              + Add More
            </Button>
            <Button
              onClick={(e) => {
                e.preventDefault();
                onSubmit({ noNavigate: false });
              }}
              className="bg-[#DC2627] hover:bg-[#dc2644] "
            >
              Continue
            </Button>
          </div>
        </CardFooter>
      </Card>
    </>
  );
};

export const ContentForm: React.FC<contentFormProps> = ({
  data,
  setData,
  onSubmit,
}) => {
  const staticData = useStaticData();
  const generalState = useGeneralSettings();

  const [ContentTypeData, setContentTypeData] = useState<[] | undefined>();
  const [ContentFormatData, setContentFormatData] = useState<[] | undefined>();

  useEffect(() => {
    staticData?.getNewDataFromType("Content Type").then((e) => {
      setContentTypeData(e);
    });
  }, []);
  useEffect(() => {
    staticData?.getNewDataFromType("Content Format").then((e) => {
      setContentFormatData(e);
    });
  }, []);

  return (
    <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
      <CardHeader className=" gap-[0px] ">
        <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
          <span>
            Showcase Your Content Expertise & Style <br />{" "}
            <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
              {" "}
              👩🏻‍💻 Help us understand your voice, format, and niche
            </span>
          </span>
          <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
            <img
              className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
              src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
              alt=""
            />
            {generalState.SidebarChipsCount.content || 0}{" "}
            <span className=" ml-[2px] text-[14px] md:text-[16px] ">chips</span>
          </div>{" "}
        </CardTitle>
        <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
      </CardHeader>
      <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
        <div className="flex flex-col gap-[12px]">
          <span className="text-[#E2E8F0] text-[12px] md:text-[14px] ">
            Select your niche content categories (MAXIMUM 6)
          </span>
          <div className="flex flex-wrap gap-[12px]">
            <TagsField1
              data={ContentTypeData ?? []}
              values={data?.categories}
              setValues={(value: []) => {
                data?.categories?.length < 6 &&
                  setData({ ...data, categories: value });
              }}
              limit={6}
              tagName={"categoryName"}
            />
          </div>
        </div>
        <div className="flex flex-col gap-[12px]">
          <span className="text-[#E2E8F0] text-[12px] md:text-[14px] font-[400] ">
            Give brands a glimpse into your style (SELECT ALL THAT APPLY)
          </span>
          <div className="flex flex-wrap gap-[12px]">
            <TagsField1
              data={ContentFormatData ?? []}
              values={data?.formats}
              setValues={(value: []) => {
                setData({ ...data, formats: value });
              }}
              limit={ContentFormatData?.length}
              tagName={"contentFormatName"}
            />
          </div>
        </div>
      </CardContent>
      <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-end">
        <Button
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="bg-[#DC2627] hover:bg-[#dc2644] "
        >
          Save & Continue
        </Button>
      </CardFooter>
    </Card>
  );
};

export const AudienceDataForm: React.FC<audienceDataFormProps> = ({
  data,
  setData,
  onSubmit,
  // onClick,
}) => {
  const staticData = useStaticData();
  const generalState = useGeneralSettings();
  const navigate = useNavigate();
  const authState = useAuth();

  const [audienceCategory, setAudienceCategoryData] = useState<
    [] | undefined
  >();
  const [platformData, setPlatformData] = useState<[] | undefined>();

  useEffect(() => {
    staticData
      ?.getNewDataFromType("lkd_super_master_audienceType")
      .then((e) => {
        setAudienceCategoryData(e);
      });
  }, []);

  useEffect(() => {
    staticData?.getNewDataFromType("Audience Platform").then((e) => {
      setPlatformData(e);
    });
  }, []);

  const handleChangeData = (value: string, index: number, field: string) => {
    setData((prevData) => {
      const newArray = [...prevData.platforms];
      const updatedObj = newArray[index];
      if (field === "audience" && parseInt(value) >= 0) {
        updatedObj[field] = parseInt(value);
        newArray[index] = updatedObj;
      } else if (field !== "audience") {
        updatedObj[field] = value;
        newArray[index] = updatedObj;
      }
      return { types: data?.types, platforms: newArray };
    });
  };

  const handleAddGroup = () => {
    let newArr;

    if (data?.platforms) {
      newArr = [
        ...data.platforms,
        {
          platform: "",
          audience: null,
          link: "",
        },
      ];
    } else {
      newArr = [
        {
          platform: "",
          audience: "",
          link: "",
        },
      ];
    }

    setData((prev) => ({
      ...prev,
      platforms: newArr,
    }));
  };

  const findPlatformName = (e) => {
    const masterItem: any = platformData?.find((item: any) => {
      return item?._id?.includes(e?.platform);
    });
    return masterItem?.audiencePlatformName;
  };
  return (
    <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
      <CardHeader className=" gap-[0px] ">
        <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
          <span>
            Audience & Community <br />{" "}
            <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
              {" "}
              🌟 Brands look for creators who resonate with their target
              audience!
            </span>
          </span>
          <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
            <img
              className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
              src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
              alt=""
            />
            {generalState.SidebarChipsCount.audience || 0}{" "}
            <span className="ml-[2px] text-[14px] md:text-[16px] ">chips</span>
          </div>{" "}
        </CardTitle>
        <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
      </CardHeader>
      <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
        {!authState?.loggedUser?.extensionUsage?.lastSyncTime && (
          <div className="flex flex-col gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Tell us what kind of people follow you (MAXIMUM 6)
            </span>
            <div className="flex flex-wrap gap-[12px]">
              <TagsField1
                data={audienceCategory ?? []}
                values={data?.types}
                setValues={(value: []) => {
                  data?.types?.length < 6 && setData({ ...data, types: value });
                }}
                limit={6}
                tagName={"LkdAudienceTypeName"}
              />
            </div>
          </div>
        )}
        <div className="flex flex-col gap-[20px]">
          <div className=" flex flex-col gap-[8px] ">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              A little about where brands can find your audience (MAXIMUM 6)
            </span>
            <span className="text-[#A3A3A3] text-[12px] md:text-[14px]  ">
              Add all the groups or social media s where you connect with your
              audience
            </span>
          </div>
          {data?.platforms
            .filter((item) => item?.oldplatform !== "LinkedIn Profile")
            ?.map((e, index) => {
              return (
                <div className="grid w-full items-center gap-[12px] text-[#A3A3A3]">
                  <div className="flex gap-[12px] ">
                    <div className="flex w-full flex-col space-y-1.5 ">
                      {/* <Label htmlFor="framework">Framework</Label> */}
                      <Select
                        defaultValue={findPlatformName(e)}
                        onValueChange={(value) => {
                          setData((prevData) => {
                            const newArray = [...prevData.platforms];
                            const updatedObj = newArray[index];
                            updatedObj.platform = value;
                            newArray[index] = updatedObj;
                            return { types: data?.types, platforms: newArray };
                          });
                        }}
                      >
                        <SelectTrigger
                          className="bg-transparent border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 text-[12px] md:text-[14px] "
                          id="gender"
                        >
                          <SelectValue placeholder={findPlatformName(e)} />
                        </SelectTrigger>
                        <SelectContent
                          className=" border-[#262626] text-[12px] md:text-[14px]"
                          position="popper"
                        >
                          {platformData?.map((item: any, index) => {
                            return (
                              <SelectItem key={index} value={item?._id}>
                                {item?.audiencePlatformName}
                              </SelectItem>
                            );
                          })}
                        </SelectContent>
                      </Select>
                    </div>
                    <div className="flex w-full flex-col space-y-1.5">
                      {/* <Label htmlFor="name">Name</Label> */}
                      <Input
                        value={e?.audience}
                        onChange={(e) =>
                          handleChangeData(e.target.value, index, e.target.name)
                        }
                        name="audience"
                        id="audience"
                        className=" bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                        placeholder="Audience Size"
                      />
                    </div>
                  </div>

                  <div className="flex w-full flex-col space-y-1.5">
                    {/* <Label htmlFor="name">Name</Label> */}
                    <Input
                      className=" bg-transparent placeholder:text-[#A3A3A3] text-[12px] md:text-[14px] placeholder:text-[12px] md:placeholder:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0  "
                      placeholder="🔗 Paste URL"
                      value={e.link}
                      onChange={(e) => {
                        return handleChangeData(
                          e.target.value,
                          index,
                          e.target.name
                        );
                      }}
                      name="link"
                      id="link"
                    />
                  </div>
                </div>
              );
            })}
          <div>
            <Button
              onClick={handleAddGroup}
              className=" flex p-2 gap-[8px] bg-transparent border-[#262626] md:px-[25px]"
            >
              <Plus size={16} color="#A3A3A3" /> Add more
            </Button>
          </div>
        </div>
      </CardContent>
      <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-end">
        <span
          onClick={(e) => {
            e.preventDefault();
            navigate("/influencer/build_profile?page=collab");
          }}
          className="hidden cursor-pointer text-[#E2E8F0] font-inter text-[14px] font-[500] leading-[24px]   "
        >
          I’ll do it later
        </span>
        <Button
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
          className="bg-[#DC2627] hover:bg-[#dc2644] "
        >
          Save & Continue
        </Button>
      </CardFooter>
    </Card>
  );
};

export const ChargesForm: React.FC<ChargesFormProps> = ({
  data,
  setData,
  // errorArray,
  onSubmit,
  onClick,
}) => {
  const generalState = useGeneralSettings();

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target?.name]: e.target?.value >= 0 ? e.target?.value : 0,
    });
  };

  return (
    <>
      <Card className="w-full font-inter bg-[#171717] border-[#262626] rounded-[8px] gap-[20px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
            <span>
              Get Paid Right: Set Your Rates <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                🌟 Set clear pricing, attract ideal <br /> brands, & get paid
                what you're worth
              </span>
            </span>
            <div className="ml-auto text-[16px] md:text-[20px]  font-[500] flex items-center justify-center md:gap-[4px] ">
              <img
                className=" w-[24px] md:w-[32px] h-[24px] md:h-[32px] "
                src="https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/f06623be8acc04b336d91541c5dccaec.gif"
                alt=""
              />
              {generalState.SidebarChipsCount.charges || 0}{" "}
              <span className="ml-[2px] text-[14px] md:text-[16px] ">
                chips
              </span>
            </div>{" "}
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent className="px-[16px] md:px-6 flex flex-col gap-[40px] ">
          <div className="flex flex-col gap-[6px] md:gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Per-Post Pricing
            </span>
            <p className="text-xs md:text-[12px] text-[#A3A3A3] font-[400]">
              Define a minimum & maximum price for a single sponsored LinkedIn
              post <br />
              Only enter a numeric value
            </p>
            <div className="flex gap-[12px]">
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Min. price in Rs."
                value={data?.PostMinPrice}
                onChange={handleChange}
                name="PostMinPrice"
                id="PostMinPrice"
                type="Number"
                min={0}
              />
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Max. price in Rs."
                value={data?.PostMaxPrice}
                type="Number"
                onChange={handleChange}
                name="PostMaxPrice"
                id="PostMaxPrice"
                min={0}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[6px] md:gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Monthly Post Bundles
            </span>
            <p className="text-xs md:text-[12px] text-[#A3A3A3] font-[400]">
              Offer bundled LinkedIn posts at your desired minimum & maximum
              prices <br />
              Only enter numeric values
            </p>
            <div className="flex gap-[12px]">
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="No. of Posts/Month"
                value={data?.MonthlyNumberOfPost}
                onChange={handleChange}
                type="Number"
                name="MonthlyNumberOfPost"
                id="MonthlyNumberOfPost"
                min={0}
              />
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Min. price in Rs."
                value={data?.MonthlyMinPrice}
                onChange={handleChange}
                type="Number"
                name="MonthlyMinPrice"
                id="MonthlyMinPrice"
                min={0}
              />
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Max. price in Rs."
                value={data?.MonthlyMaxPrice}
                onChange={handleChange}
                name="MonthlyMaxPrice"
                id="MonthlyMaxPrice"
                type="Number"
                min={0}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[6px] md:gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Yearly Value Packages
            </span>
            <p className="text-xs md:text-[12px] text-[#A3A3A3] font-[400]">
              Offer bundled LinkedIn posts at your desired minimum & maximum
              prices <br />
              Only enter numeric values
            </p>
            <div className="flex gap-[12px]">
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="No. of Posts/Year"
                value={data?.YearlyNumberOfPost}
                onChange={handleChange}
                name="YearlyNumberOfPost"
                type="Number"
                id="YearlyNumberOfPost"
                min={0}
              />
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Min. price in Rs."
                value={data?.YearlyMinPrice}
                onChange={handleChange}
                name="YearlyMinPrice"
                type="Number"
                id="YearlyMinPrice"
                min={0}
              />
              <Input
                className=" bg-transparent text-[#fff] placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                placeholder="Max. price in Rs."
                value={data?.YearlyMaxPrice}
                onChange={handleChange}
                type="Number"
                name="YearlyMaxPrice"
                id="YearlyMaxPrice"
                min={0}
              />
            </div>
          </div>
          <div className="flex flex-col gap-[6px] md:gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Open to non-monetary offers like Free Gifts & Barters?
            </span>
            <div className="flex gap-5">
              <Button
                className={
                  data?.AcceptFreeBies
                    ? "destructive text-[12px] md:text-[14px]"
                    : "bg-transparent hover:bg-[#381c1c] text-[12px] md:text-[14px]"
                }
                variant={data?.AcceptFreeBies ? "destructive" : "default"}
                onClick={() => setData({ ...data, AcceptFreeBies: true })}
              >
                Yes
              </Button>
              <Button
                className={
                  !data?.AcceptFreeBies
                    ? "destructive text-[12px] md:text-[14px]"
                    : "bg-transparent hover:bg-[#381c1c] text-[12px] md:text-[14px]"
                }
                variant={!data?.AcceptFreeBies ? "destructive" : "default"}
                onClick={() => setData({ ...data, AcceptFreeBies: false })}
              >
                No
              </Button>
            </div>
          </div>
          <div className="flex flex-col gap-[6px] md:gap-[12px]">
            <span className="text-[#E2E8F0] text-[12px] md:text-[14px]  ">
              Open to Pricing Negotiation?
            </span>
            <div className="flex gap-5">
              <Button
                className={
                  data?.isNegotiable
                    ? "destructive text-[12px] md:text-[14px]"
                    : "bg-transparent hover:bg-[#381c1c] text-[12px] md:text-[14px] "
                }
                variant={data?.isNegotiable ? "destructive" : "default"}
                onClick={() => setData({ ...data, isNegotiable: true })}
              >
                Yes
              </Button>
              <Button
                className={
                  !data?.isNegotiable
                    ? "destructive text-[12px] md:text-[14px] "
                    : "bg-transparent hover:bg-[#381c1c] text-[12px] md:text-[14px]"
                }
                variant={!data?.isNegotiable ? "destructive" : "default"}
                onClick={() => setData({ ...data, isNegotiable: false })}
              >
                No
              </Button>
            </div>
          </div>
        </CardContent>
        <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-end md:justify-between">
          <span
            onClick={() => onClick()}
            className="hidden md:block cursor-pointer text-[#E2E8F0] font-inter text-[14px] font-[500] leading-[24px]   "
          >
            I’ll do it later
          </span>
          <Button
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            className="bg-[#DC2627] hover:bg-[#dc2644] "
          >
            Save & Continue
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};

export const TopLinksForm: React.FC<TopLinksFormProps> = ({
  data,
  setData,
  onSubmit,
}) => {
  const [linkErrors, setLinkErrors] = useState<boolean[]>([]);

  const getFaviconIcon = (url: string) => {
    const urlObj = new URL(url);
    // return `https://t2.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${urlObj.hostname}&size=50`
    // return `https://www.google.com/s2/favicons?domain=${urlObj.hostname}`;
    return `https://icons.duckduckgo.com/ip3/${urlObj.hostname}.ico`;
  };

  const handleTopLinkChangeData = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const { name, value } = e.target;
    let icon = data?.topLinks?.[index]?.icon;
    let isValid = true;

    const urlRegex = /^(http|https):\/\/[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+/;
    if (name === "link") {
      let newUrl = value;
      if (!urlRegex.test(value)) {
        newUrl = `http://${value}`;
      }
      if (urlRegex.test(newUrl)) {
        icon = getFaviconIcon(newUrl);
      } else {
        isValid = false;
      }
    }

    if (name === "linkText") {
      const link = data?.topLinks?.[index]?.link;
      if (link) {
        if (!urlRegex.test(link)) {
          const newUrl = `http://${link}`;
          if (urlRegex.test(newUrl)) {
            icon = getFaviconIcon(newUrl);
            setData((prevData) => {
              const updatedTopLinks = [...prevData.topLinks];
              updatedTopLinks[index] = {
                ...updatedTopLinks[index],
                link: newUrl,
                icon,
              };
              return { ...prevData, topLinks: updatedTopLinks };
            });
          } else {
            isValid = false;
          }
        }
      }
    }

    setLinkErrors((prevErrors) => {
      const updatedErrors = [...prevErrors];
      updatedErrors[index] = !isValid;
      return updatedErrors;
    });

    setData((prevData) => {
      const updatedTopLinks = [...prevData.topLinks];
      updatedTopLinks[index] = {
        ...updatedTopLinks[index],
        [name]: value,
        icon,
      };
      return { ...prevData, topLinks: updatedTopLinks };
    });
  };

  const addNewLink = () => {
    mixpanel.track("clicked: Add New Top Link - button");
    setData((prevData) => ({
      ...prevData,
      topLinks: [...prevData.topLinks, { link: "", linkText: "", icon: "" }],
    }));
    setLinkErrors((prevErrors) => [...prevErrors, false]);
  };

  const removeLink = (index: number) => {
    mixpanel.track("clicked: Remove Top Link - button");
    setData((prevData) => {
      const updatedTopLinks = prevData.topLinks.filter((_, i) => i !== index);
      return { ...prevData, topLinks: updatedTopLinks };
    });
    setLinkErrors((prevErrors) => prevErrors.filter((_, i) => i !== index));
  };

  const isFormValid = linkErrors.every((error) => !error);

  return (
    <>
      {data?.topLinks?.[0]?.linkText?.length > 0 && (
        <div className="w-full block md:hidden space-y-2">
          <SectionCard
            icon={"📌"}
            title="My Top Links"
            subtitle="Links to my top social media profiles & websites"
          >
            <ScrollArea className="w-full whitespace-nowrap">
              <div className="flex w-max space-x-4 py-4">
                <TopLinksPreview data={data} />
              </div>
              <ScrollBar orientation="horizontal" />
            </ScrollArea>
          </SectionCard>
        </div>
      )}
      <Card className="w-full h-max font-inter bg-[#171717] border-[#262626] rounded-[8px] ">
        <CardHeader className=" gap-[0px] ">
          <CardTitle className=" text-[#FFFFFF] text-[14px] md:text-[16px] flex">
            <span>
              Your Top Links <br />{" "}
              <span className="text-[#A3A3A3] text-[12px] md:text-[14px] flex items-center mt-0">
                {" "}
                Add links that you want to highlight on your profile.
              </span>
            </span>
          </CardTitle>
          <CardDescription className=" text-[#A3A3A3] font-inter text-[14px] flex items-center mt-0 "></CardDescription>
        </CardHeader>
        <CardContent className="px-[16px] md:px-6">
          <form className="gap-[20px] flex flex-col">
            <div className="space-y-5">
              {data?.topLinks?.map((item, index) => {
                return (
                  <div key={index} className="flex flex-col gap-2">
                    <div className="flex flex-col md:flex-row gap-2 md:gap-5 items-center">
                      {/* <div className="text-muted-foreground hover:text-white cursor-move">
                            <GripHorizontal size={16} />
                          </div> */}
                      <div className="flex gap-2 w-full">
                        <Input
                          value={item?.link}
                          onChange={(e) => handleTopLinkChangeData(e, index)}
                          name="link"
                          id="link"
                          className="text-white bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                          placeholder="Link"
                        />
                        <div
                          onClick={() => removeLink(index)}
                          className="flex items-center md:hidden hover:text-[#dc2644] text-white rounded-full"
                        >
                          <Trash size={16} />
                        </div>
                      </div>
                      <Input
                        value={item?.linkText}
                        onChange={(e) => handleTopLinkChangeData(e, index)}
                        name="linkText"
                        id="linkText"
                        className="text-white bg-transparent placeholder:text-[#A3A3A3] placeholder:text-[12px] md:placeholder:text-[14px] text-[12px] md:text-[14px] border-[#262626] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#DC2627] focus-visible:ring-offset-0 "
                        placeholder="Link Text"
                      />
                      <div
                        onClick={() => removeLink(index)}
                        className="hidden md:flex md:items-center hover:text-[#dc2644] text-white rounded-full"
                      >
                        <Trash size={16} />
                      </div>
                    </div>
                    {linkErrors[index] && (
                      <span className="text-red-500 text-sm">Invalid link</span>
                    )}
                  </div>
                );
              })}

              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  addNewLink();
                }}
                className="flex p-2 gap-[8px] bg-transparent border-[#262626] md:px-[25px] font-inter font-light text-xs"
              >
                <Plus size={16} /> Add New Link
              </Button>
            </div>
          </form>
        </CardContent>
        <CardFooter className="fixed md:static bottom-0 md:bottom:auto z-50 md-z-auto w-full md:w-full py-2.5 md:py-auto bg-[#000000] md:bg-transparent md:shadow-none flex justify-end">
          <Button
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            className="bg-[#DC2627] hover:bg-[#dc2644] "
            disabled={!isFormValid}
          >
            Save
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};

export const TopLinksPreview: React.FC<TopLinksPreviewProps> = ({ data }) => {
  return (
    <>
      {data?.topLinks?.[0]?.linkText
        ? data?.topLinks?.map((item, index) => {
            if (item?.linkText?.length > 0) {
              return (
                <>
                  <div
                    key={index}
                    className="bg-white w-fit md:w-full group rounded-[8px] border-[1px] border-solid border-[#262626] hover:border-[#DC2627] md:p-[1rem] py-[0.75rem] px-[1rem] flex justify-between gap-5 items-center cursor-pointer"
                    onClick={() => {
                      mixpanel.track("Top Link Preview Clicked", {
                        link: item?.link,
                      });
                      window.open(item?.link, "_blank");
                    }}
                  >
                    <div className="flex gap-2 items-center">
                      <div className="rounded-full shrink-0">
                        {item?.icon && (
                          <img
                            src={`${host}/api/file/proxyImage?imageUrl=${encodeURIComponent(
                              item?.icon
                            )}`}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "https://cdn-icons-png.flaticon.com/512/5339/5339181.png";
                            }}
                            alt=""
                            className="object-cover size-[26px]"
                          />
                        )}
                      </div>
                      <span className="text-black font-medium">
                        {item.linkText}
                      </span>
                    </div>
                    <SquareArrowOutUpRight
                      size={16}
                      className="text-black p-0 group-hover:text-[#DC2627] bg-transparent"
                    />
                  </div>
                </>
              );
            }
          })
        : "Add links to see preview"}
    </>
  );
};
